module.exports = __webpack_public_path__ + "img/4.770d8501.png";